<template>
    <div class="container remove-padding-margin">
        <main class="add-padding-default">
            <div class="fixed-judul fixed-top">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding-margin">
						<!--<img @click="" src="../../assets/img/x2.svg" alt="">-->
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center">
                        <h6 class="remove-margin">Reset Kata Sandi</h6>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">

                    </div>
                </div>
            </div>
            <div class="content-2 flex-100">
                <div class="flex-1">
                    <div class="text-outlet">
                        <div class="paragraphme">
	                        Masukkan kata sandi baru untuk login dengan email {{ emailset }}.
                        </div>
                    </div>
                    <form class="form-float form-color remove-padding" action="">
                        <div class="form-group">
                            <label for="password-field2">Kata sandi baru</label>
                            <input type="password" class="form-control" v-on:keyup="cekValidate" @keyup="listenCapslock($event, 'password-field2')" v-model="password1" id="password-field2"/>
                            <span toggle="#password-field2" v-on:click="changeViewPass"
                                  class="fa fa-eye field-icon toggle-password1"></span>
	                        <ErrorMessage class="error" label="Password" :validation="$v.password1"></ErrorMessage>
                        </div>

                        <div class="form-group">
	                        <label for="password-field" class="mar-top-bot-10">Ulangi Kata sandi baru</label>
                            <input type="password" class="form-control" style="padding-right: 50px" v-on:keyup="cekValidate" @keyup="listenCapslock($event, 'password-field')"
                                   v-model="password" id="password-field"/>
                            <span toggle="#password-field" v-on:click="changeViewPassField"
                                  class="fa fa-eye field-icon toggle-password2"></span>
	                        <ErrorMessage class="error" label="Password" :validation="$v.password"></ErrorMessage>
							<!--<span class="unmatch" id="alertUnmatch">password tidak cocok</span>-->
                        </div>
                    </form>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long" @click="changePassword" id="btnSend">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span>
                        <span id="textbtn">Reset Kata Sandi</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, sameAs, required} from "vuelidate/lib/validators";

    export default {
        name: "ResetPassword",
	    components: { ErrorMessage },
        mounted() {
            var emailLocal = "" + localStorage.getItem("forgot_password");
            this.emailset = emailLocal;
            this.codeEncryption = this.$route.params.code
            $("#alertUnmatch").hide();
            $('.fa.fa-times').hide();
        },

        data() {
            return {
                password: "",
                password1: "",
                emailset: "",
                isClicked: false,
	            codeEncryption: "",
            }
        },
	    validations: {
		    password1: {
		    	required,
			    minLength: minLength(8)
		    },
		    password: {
		    	required,
			    minLength: minLength(8),
			    sameAsPassword: sameAs('password1'),
		    },
	    },

        methods: {
	        combinationpass(){
		        if(this.password !== '') {
			        var numeric = /[0-9]/;
			        var alphabeth = /[A-Za-z]/;
			        if(!numeric.test(this.password) || !alphabeth.test(this.password)) {
				        return true;
			        }
		        }else {
			        return false
		        }
	        },
	
	        combinationpass1(){
		        if(this.password1 !== '') {
			        var numeric = /[0-9]/;
			        var alphabeth = /[A-Za-z]/;
			        if(!numeric.test(this.password1) || !alphabeth.test(this.password1)) {
				        return true;
			        }
		        }else {
			        return false
		        }
	        },
            changeViewPass(event) {
                if ($('#password-field2').attr("type") == "password") {
                    $('.toggle-password1').removeClass('fa fa-eye');
                    $('.toggle-password1').addClass('fa fa-eye fa-eye-slash');
                    $('#password-field2').attr("type", "text");
                } else {
                    $('.toggle-password1').removeClass('fa fa-eye fa-eye-slash');
                    $('.toggle-password1').addClass('fa fa-eye');
                    $('#password-field2').attr("type", "password");
                }
            },

            changeViewPassField(event) {
                if ($('#password-field').attr("type") == "password") {
                    $('.toggle-password2').removeClass('fa fa-eye');
                    $('.toggle-password2').addClass('fa fa-eye fa-eye-slash');
                    $('#password-field').attr("type", "text");
                } else {
                    $('.toggle-password2').removeClass('fa fa-eye fa-eye-slash');
                    $('.toggle-password2').addClass('fa fa-eye');
                    $('#password-field').attr("type", "password");
                }
            },

            cekValidate() {
	            this.password = this.password.replace(/[^0-9A-Za-z]+/, '');
	            this.password1 = this.password1.replace(/[^0-9A-Za-z]+/, '');
            	return
                var passData = this.password;
                var passPass = this.password1
                var lenPass = passData.length;
                var lengPass = passPass.length;
                if (lenPass && lengPass >= 1) {
                    if (passData === passPass) {
                        $("#password-field").removeClass("inputUnmatch");
                        $("#alertUnmatch").fadeOut();
                        if ((lenPass >= 6) && (lengPass >= 6)) {
                            $('#btnSend').prop('disabled', false);
                        } else {
                            $('#btnSend').prop('disabled', true);
                        }
                    } else {
                        $("#password-field").addClass("inputUnmatch");
                        $("#alertUnmatch").fadeIn();
                        if (passData !== passPass) {
                            $('#btnSend').prop('disabled', true);
                        }
                    }
                }
            },

	        errorValidation() {
            	if (this.$v.password1.$invalid || this.$v.password.$invalid) {
            		this.$v.password1.$touch()
		            this.$v.password.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return true
	            }
            	return false
	        },
            async changePassword() {
            	if (this.errorValidation()) {
            		return
	            }
            	if (this.combinationpass && this.combinationpass1()) {
		            this.$toast.error("Password harus mengandung kombinasi huruf dan angka")
		            return
	            }
                $('#btnSend').prop('disabled', true);
                $('#textbtn').hide();
                this.isClicked = true;
                var password = this.password;
                var idowner = localStorage.getItem("idowner");
                try {
                    const dataForm = new FormData;
                    dataForm.append('password', password);
                    dataForm.append('code_encryption', this.codeEncryption);
                    // const res = await this.$axios.post(this.$baseurl + '/auth/reset_password', dataForm);
	                const res = await this.$axios.post(this.$baseurl + '/auth/verifikasi_reset_password', dataForm);
	                if (res.data.status) {
	                	localStorage.removeItem("forgot_password")
		                this.$toast.success("Password anda telah berhasil di reset")
                        setTimeout(() => {
                            this.$router.push({name: 'login'})
                        }, 2500)
                    } else {
	                	this.$toast.error(res.data.msg)
		                this.isClicked = false;
		                $('#btnSend').prop('disabled', false);
		                $('#textbtn').show();
	                }
                } catch (e) {
                	this.$catch_error_response(e)
                    this.isClicked = false;
                    $('#btnSend').prop('disabled', false);
                    $('#textbtn').show();
                }
            },
        },
    }
</script>

<style scoped>
    .paragraphme {
        font-weight: normal;
        font-size: 16px;
        line-height: 140%;
        align-items: center;
        letter-spacing: -0.02em;
        color: #333333;

    }

    .unmatch {
        color: #ff5757;
        font-size: 14px;
        margin-top: -20px;
    }

    .inputUnmatch {
        border-color: #ff5757 !important;
    }
</style>